import React,{ useState, useEffect, useRef }  from 'react';
import { Button, Modal} from 'semantic-ui-react'
import {v1 as uuid} from 'uuid'
import EditUser from '../EditUser/EditUser'


const ModalEditUser=({open,setOpen,db,UID,setRevision})=>{
    
 

    const [user,setUser]=useState(
        {
            UID:null,
            Vorname:'',
            Nachname:'',
            Strasse:'',
            Strasse2:'',
            PLZ:'',
            Ort:'',
            Land:'CH',
            mobil:'',
            Festnetz:'',
            email:'',
            attr:{},
            certified:'personal',
            ShopId:'',


        }
    )

    const usersDB=db.users
    const hasError=useRef(true)  // does it contain an error
    const [submitted,setSubmitted] = useState(false)  // is form submitted the first time?


    const closeModalSubmit=()=>
    {
        {
            setRevision(revision=>++revision)
            setOpen(false)
        }
    }

    useEffect(()=>{
        if(!UID)
        {
            setUser(    {
                UID:uuid(),
                Vorname:'',
                Nachname:'',
                Strasse:'',
                Strasse2:'',
                PLZ:'',
                Ort:'',
                Land:'CH',
                mobil:'',
                Festnetz:'',
                email:'',
                attr:{},
                certified:'personal',
                ShopId:'',
            })
        }
        else
        {
            const getUser= async ()=>
            {
                const u=await usersDB.where({UID:UID}).first()
                setUser(u)
            }
            getUser()
            
        }
    },[UID,open])

    const deleteUser=()=>
    {
        usersDB.where({UID:user.UID}).delete()
        setSubmitted(false)
        setRevision(revision=>++revision)
        
        setOpen(false)

    }

    return( 
    <Modal 
        open={open}           
        onClose={e=>setOpen(false)}
    >
        <Modal.Header>Benutzer ändern</Modal.Header>
        <Modal.Content>

            <EditUser
                user={user}
                setUser={setUser}
                db={db}
                hasError={hasError}
                deleteUser={deleteUser}
                close={e=>setOpen(false)}
                afterSubmit= { closeModalSubmit}
            />
        </Modal.Content>
    </Modal>
    )
    
}
export default ModalEditUser
